<template>
  <rest-list-action icon="el-icon-delete" :title="$t(title)" :click="click" />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'RestListActionDelete',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    },

    name: {
      type: String,
      required: false
    },

    deleteMessage: {
      type: [Function, String],
      required: false
    },

    htmlWarningMsg: {
      type: Boolean,
      required: false,
      default: false
    },
    clearMask: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: 'RestList_Action_Delete'
    }
  },

  methods: {
    async click() {
      let msg = this.deleteMessage
      if (this.deleteMessage && typeof this.deleteMessage === 'function') {
        msg = await this.deleteMessage()
      }
      this.$msgbox({
        title: this.$t('RestList_DeleteTitle'),
        message: msg || this.$t('RestList_DeletePrompt', { label: this.name }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_DeleteConfirmButton'),
        cancelButtonText: this.$t('RestList_DeleteCancelButton'),
        center: true,
        dangerouslyUseHTMLString: this.htmlWarningMsg
      })
        .then(() => {
          RestApi(this.endpoint)
            .then(() => {
              this.$message({
                message: this.$t('RestList_DeleteSuccessMessage'),
                type: 'success'
              })
              this.restList.refresh()
            })
            .catch(error => {
              this.$message({
                message: error.message,
                type: 'error'
              })
            })
        })
        .finally(() => {
          if (this.clearMask) {
            document.querySelector('.v-modal').remove()
            EventBus.$emit('applyLabels', null)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionDelete.vue